import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { getControlledProduct } from '../Api'

export default generateApiAction({
  baseType: Types.CTRL_PRODS.GET,
  api: getControlledProduct,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/controlledProducts/GetAction.js